<template>
  <a-modal
    :title="title"
    :maskClosable="false"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-row :gutter="24">
          <a-col :md="12" :sm="8">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="岗位名称"
            >
              <a-input
                placeholder="请输入岗位名称"
                :max-length="16"
                v-decorator="['postName', validatorRules.postName]"
              />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="8">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="招聘人数"
            >
              <a-input
                placeholder="请输入招聘人数"
                :max-length="16"
                v-decorator="['number', validatorRules.number]"
              />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="8">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="地址"
            >
              <a-input
                placeholder="请输入地址"
                :max-length="16"
                v-decorator="['address', validatorRules.address]"
              />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="8">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="职位描述"
            >
              <a-input
                placeholder="请输入职位描述"
                :max-length="16"
                v-decorator="['positionDes', validatorRules.positionDes]"
              />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="8">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="任职资格"
            >
              <a-input
                placeholder="请输入任职资格"
                :max-length="16"
                v-decorator="['qualifications', validatorRules.qualifications]"
              />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="8">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="投递邮箱"
            >
              <a-input
                placeholder="请输入投递邮箱"
                :max-length="16"
                v-decorator="['email', validatorRules.email]"
              />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="8">
            <a-form-item
              label="结束时间"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <j-date
                placeholder="请选择招聘结束时间"
                v-decorator="['endTime']"
                dateFormat="YYYY-MM-DD"
                :trigger-change="true"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <!-- <a-col :md="12" :sm="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="类别">
              <a-select v-decorator="['category', {}]">
                <a-select-option value="1">电话</a-select-option>
                <a-select-option value="2">会话</a-select-option>
                <a-select-option value="3">机器人</a-select-option>
              </a-select>
            </a-form-item>
          </a-col> -->
          <a-col :md="12" :sm="8"> </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import JDate from '@/components/jeecg/JDate';
import JDictSelectTag from '@/components/dict/JDictSelectTag';
export default {
  data() {
    return {
      title: '新增',
      visible: false,
      model: {},
      typeText: '',
      value: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        // id: { rules: [{ required: true, message: '请输入id!' }] },
        // name: { rules: [{ required: true, message: '请输入岗位名称!' }] },
        qualifications: {
          rules: [{ required: true, message: '请输入任职资格!' }]
        },
        postName: { rules: [{ required: true, message: '请输入岗位名称!' }] },
        number: { rules: [{ required: true, message: '请输入招聘人数!' }] },
        address: { rules: [{ required: true, message: '请输入地址!' }] },
        positionDes: {
          rules: [{ required: true, message: '请输入职位描述!' }]
        },
        email: { rules: [{ required: true, message: '请输入投递邮箱!' }] },
        endTime: { rules: [{ required: true, message: '请输入招聘时间!' }] }
      },
      url: {
        add: process.env.VUE_APP_CMS_CONTENT + '/content/position/save',
        edit: process.env.VUE_APP_CMS_CONTENT + '/content/position/save'
      }
    };
  },
  components: {
    JDate,
    JDictSelectTag
  },
  methods: {
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'id',
            'Delivermail',
            'description',
            'endTime',
            'site',
            'postName',
            'name',
            'methodName',
            'inviteNumber',
            'site'
          )
        );
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    onChange() {},
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'POST';
          } else {
            httpurl += this.url.edit;
            method = 'POST';
          }
          let formData = Object.assign(this.model, values);
          console.log(this.model);
          //时间格式化
          httpAction(httpurl, formData, method).then(res => {
            console.log(res);
            if (res.success) {
              that.$message.success(res.message);
              that.$emit('ok', that.model);
              that.confirmLoading = false;
              that.close();
            } else {
              that.$message.warning(res.message);
              that.confirmLoading = false;
            }
          });
        }
      });
    },
    handleCancel() {
      this.close();
    }
  }
};
</script>

<style></style>
